
import React from "react";
import { useAdminDashboard } from "@/contexts/AdminDashboardContext";

import AddClassDialog from "@/components/admin/dialogs/AddClassDialog";
import AddSubscriptionDialog from "@/components/admin/dialogs/AddSubscriptionDialog";
import AddGiftCardDialog from "@/components/admin/dialogs/AddGiftCardDialog";
import ScheduleClassesDialog from "@/components/admin/dialogs/ScheduleClassesDialog";

const AdminDashboardDialogs: React.FC = () => {
  const {
    isAddClassOpen,
    setIsAddClassOpen,
    newClass,
    setNewClass,
    handleCreateClass,
    isAddSubscriptionOpen,
    setIsAddSubscriptionOpen,
    newSubscription,
    setNewSubscription,
    selectedUser,
    setSelectedUser,
    handleCreateSubscription,
    handleSelectUser,
    isAddGiftCardOpen,
    setIsAddGiftCardOpen,
    handleCreateGiftCard,
    isCreatingGiftCard,
    isScheduleDialogOpen,
    setIsScheduleDialogOpen,
    isScheduling,
    scheduleResult,
    handleScheduleClasses
  } = useAdminDashboard();

  return (
    <>
      <AddClassDialog 
        isOpen={isAddClassOpen}
        onOpenChange={setIsAddClassOpen}
        newClass={newClass}
        setNewClass={setNewClass}
        onCreateClass={handleCreateClass}
      />
      
      <AddSubscriptionDialog 
        isOpen={isAddSubscriptionOpen}
        onOpenChange={setIsAddSubscriptionOpen}
        newSubscription={newSubscription}
        setNewSubscription={setNewSubscription}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        onCreateSubscription={handleCreateSubscription}
      />
      
      <AddGiftCardDialog
        isOpen={isAddGiftCardOpen}
        onOpenChange={setIsAddGiftCardOpen}
        onCreateGiftCard={handleCreateGiftCard}
        isCreating={isCreatingGiftCard}
      />
      
      <ScheduleClassesDialog 
        isOpen={isScheduleDialogOpen}
        onOpenChange={setIsScheduleDialogOpen}
        isScheduling={isScheduling}
        scheduleResult={scheduleResult}
        onScheduleClasses={handleScheduleClasses}
      />
    </>
  );
};

export default AdminDashboardDialogs;
